// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/pagenavbar/index.scss
// module id = 3123
// module chunks = 13